<template>
  <div class="exhibitionInfo">
    <BannerSwiper :bannerData="bannerList" />
    <div class="CYT-detail-info">
      <div class="article-content">
        <div class="article">
          <div class="CYT-detail-content">

           <div class="CYT-detail-title">
            {{
              lan
                ? exhibitionData.exhibitEnTitle
                : exhibitionData.exhibitCnTitle
            }}
          </div>
            <div class="exhibitEn-Sub-Title" v-if="(lan ? exhibitionData.exhibitEnSubTitle : exhibitionData.exhibitCnSubTitle) && 
                         (lan ? exhibitionData.exhibitEnSubTitle : exhibitionData.exhibitCnSubTitle).trim()">
              ——
              {{
                lan
                  ? exhibitionData.exhibitEnSubTitle
                  : exhibitionData.exhibitCnSubTitle
              }}
            </div>
          </div>
          <div class="CYT-sub-title" v-if="(lan ? exhibitionData.exhibitStaffEn : exhibitionData.exhibitStaffCn) && 
                         (lan ? exhibitionData.exhibitStaffEn : exhibitionData.exhibitStaffCn).trim()">
             {{ lan ? 'Curators: ' : '策展人：' }}{{
                lan
                  ? exhibitionData.exhibitStaffEn
                  : exhibitionData.exhibitStaffCn
              }}
            </div>
          <div class="CYT-sub-title" v-if="(lan ? exhibitionData.exhibitArtistEn : exhibitionData.exhibitArtistCn) && 
                         (lan ? exhibitionData.exhibitArtistEn : exhibitionData.exhibitArtistCn).trim()">
             {{ lan ? 'Artists: ' : '艺术家：' }}{{
                lan
                  ? exhibitionData.exhibitArtistEn
                  : exhibitionData.exhibitArtistCn
              }}
            </div>
          <div class="CYT-sub-title">
            {{
              lan
                ? `${exhibitionData.exhibitPlaceEn}`
                : `${exhibitionData.exhibitPlaceCn}`
            }}
          </div>
          <div class="CYT-sub-title">
            {{
              lan
                ? `${
                    exhibitionData.exhibitType
                      ? "Permanent Exhibition"
                      : "Temporary Exhibition"
                  }`
                : `${exhibitionData.exhibitType ? "常展" : "临展"}`
            }}
          </div>
          <div class="detail-dec">
            <div
              class="html-show"
              v-html="lan ? exhibitionData.contentEn : exhibitionData.contentCn"
            ></div>
            <div class="share-box" v-if="!isIndex">
              <ShareQr
                :showApplet="false"
                :showHomeStay="false"
                :showLodg="false"
                :showQrType="1"
                :showQrCode="exhibitionData.wxQrCode"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="grey-line" v-if="exhibitionList.length > 0"></div>
      <EventExhibition
        v-if="exhibitionList.length > 0 && !isIndex"
        :showData="exhibitionList"
      />
      <WapExhibition
        v-if="exhibitionList.length > 0 && isIndex"
        :showData="exhibitionList"
      />
    </div>
  </div>
</template>
<script>
import ShareQr from "../components/shareQr.vue";
import EventExhibition from "../components/eventExhibition.vue";
import WapExhibition from "../components/eapExhibition.vue";
import BannerSwiper from "../components/bannerSwiper.vue";

export default {
  name: "exhibitionInfo",
  components: {
    ShareQr,
    EventExhibition,
    BannerSwiper,
    WapExhibition,
  },
  data() {
    return {
      isIndex: false,
      content: "",
      pageIndex: 1,
      bannerList: [],
      exhibitionData: {},
      exhibitionList: [],
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    pageIndex(val, oldval) {},
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      this.init();
    },
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
    
    // 监听浏览器前进后退按钮
    window.addEventListener('popstate', this.handlePopState);
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
    window.removeEventListener('popstate', this.handlePopState);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    handlePopState(event) {
      // 可以在这里添加一些返回时的特殊处理
    },
    getVideoKey() {
      return this.lan ? "videoEn" : "videoCn";
    },
    // 替换中文双引号为英文双引号
    replaceChineseQuotes(text) {
      if (!text) return text;
      // 处理HTML实体编码的中文双引号
      let result = text.replace(/&ldquo;/g, '"');
      result = result.replace(/&rdquo;/g, '"');
      // 处理直接的中文引号字符
      result = result.replace(/[“”‘’]/g, '"');
      return result;
    },

    init() {
      let id = this.$route.query.id;
      this.$api.get(
        "/exhIbit/list",
        { current: 1, pageSize: 10, showFlag: 0, id: id },
        (r) => {
          const { data, code } = r;
          if (code == 0 && data.length > 0) {
            const videoKey = this.getVideoKey(); // 获取视频属性
            const exhibitionData = data[0];
            // 处理英文富文本内容中的中文双引号
            exhibitionData.contentEn = this.replaceChineseQuotes(exhibitionData.contentEn);
            this.exhibitionData = exhibitionData;
            if (data[0][videoKey]) {
                this.bannerList =[
              {
                video: data[0][videoKey],
                videoImageCn: data[0].videoImageCn || '',  // 添加视频中文封面图
                videoImageEn: data[0].videoImageEn || ''   // 添加视频英文封面图
              },
               ...JSON.parse(data[0].image)];
            } else {
               this.bannerList = JSON.parse(data[0].image);
            }
            this.bannerList.forEach((el, index) => {
              el.id = index + 1;
              el.img = el.src || "";
            });

            this.exhibitionList = this.lan
              ? JSON.parse(data[0].imageEn)
              : JSON.parse(data[0].imageCn);
            this.exhibitionList.forEach((el) => {
              el.labelList = el.label.split("&&&");
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.content-title {
  margin-top: 20px;
}
.exhibitionInfo {
  margin-top: 94px;
}

.CYT-detail-info {
  position: relative;
  width: 1440px;
  height: 100%;
  margin: 70px auto 60px;
  background-color: #fff;
}
.article-content {
  width: 100%;
}
.article {
  width: 100%;
  height: auto;
  padding-bottom: 50px;
}
.share-box {
  margin-top: 5px;
}
.CYT-detail-content{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 90%;
}
.CYT-detail-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;

}
.exhibitEn-Sub-Title{
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-left: 10px;
}
.detail-sub-title {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 700;
}
.detail-dec {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 0 32px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 400;
}
.html-show {
  width: 80%;
}
.grey-line {
  width: 100%;
  height: 1px;
  background: #d8d8d8;
}
.show-act-box {
  width: 100%;
  margin: 60px auto 90px;
}
.act-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.CYT-sub-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  margin: 10px 0;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  padding-right: 15px;
  cursor: pointer;
}
.sub-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-top: 10px;
}
.title-right::after {
  content: "";
  position: absolute;
  top: 55%;
  right: 0px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(45deg);
  transform: translateY(-45%) rotate(45deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
@media (max-width: 1440px) {
  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 70px auto 60px;
    background-color: #fff;
  }
  .article-content {
    width: 90%;
    margin: 0 auto;
  }
  .article {
    width: 100%;
    height: auto;
    padding-bottom: 50px;
  }
}
@media (max-width: 960px) {
  .content-title {
    margin-top: 20px;
  }
  .exhibitionInfo {
    margin-top: 80px;
  }

  .CYT-detail-info {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 30px auto 30px;
    background-color: #fff;
  }
  .article {
    width: 100%;
    margin: 40px auto;
  }
  .CYT-detail-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .exhibitEn-Sub-Title{
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
}
  .detail-sub-title {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 700;
  }
  .article-content {
    width: 90%;
    margin: 0 auto;
  }
  .detail-dec {
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
    flex-direction: column;
  }
  .html-show {
    width: 100%;
  }
  .share-box {
    align-self: flex-end;
    margin-top: 20px;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 50px auto 0;
    background: #d8d8d8;
  }
  .CYTdetail .act-list {
    width: 95%;
    height: auto;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .content-title {
    width: 100%;
    margin-left: 30px;
  }
  .show-act-box {
    width: 100%;
    margin: 50px auto 0px;
  }
  .title-left {
    font-size: 26px;
    margin-left: 4%;
  }
  .title-right {
    position: relative;
    font-family: SourceHanSansCN-Regular;
    font-size: 20px;
    color: #98989f;
    text-align: left;
    font-weight: 400;
    padding-right: 15px;
    cursor: pointer;
  }
  .sub-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    margin-top: 10px;
  }
  .title-right::after {
    content: "";
    position: absolute;
    top: 55%;
    right: 0px;
    width: 8px;
    height: 8px;
    border-top: 2px solid #666666;
    border-right: 2px solid #666666;
    -webkit-transform: translateY(-45%) rotate(45deg);
    transform: translateY(-45%) rotate(45deg);
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #666666;
    border-right-width: 1px;
    border-right-style: solid;
    border-right-color: #666666;
  }
}
@media (max-width: 640px) {
  .CYT-detail-title {
    font-size: 22px;
  }
  .exhibitEn-Sub-Title {
    font-size: 22px;
  }
  .title-left {
    font-size: 22px;
    margin-left: 0%;
  }
  .CYT-sub-title {
    font-size: 13px;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .detail-sub-title {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .detail-dec {
    font-size: 13px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  .article {
    margin: 10px auto;
  }
  .grey-line {
    width: 90%;
    height: 1px;
    margin: 30px auto 0;
    background: #d8d8d8;
  }
  .show-act-box {
    width: 100%;
    margin: 20px auto 0px;
  }
}
</style>